// Module
var code = `<div class="term-deposit-section" ng-show="\$ctrl.sectionType === 'general'">
  <ng-form name="\$ctrl.generalForm">
    <div class="form-column">
      <form-section form-title="'Product info'">
        <form-section-field field-title="'Name'">
          <input
            type="text"
            ng-model="\$ctrl.accountType.productDefinition.productName"
            required
            ng-minlength="1"
            maxlength="64"/>
        </form-section-field>
        <form-section-field field-title="'Description'">
          <input
            type="text"
            ng-model="\$ctrl.accountType.productDefinition.description"
            maxlength="512"/>
        </form-section-field>
        <form-section-field field-title="'Code'">
          <input
            required
            type="text"
            ng-model="\$ctrl.accountType.productDefinition.productTypeCode"
            minlength="1"
            maxlength="4"/>
        </form-section-field>
      </form-section>

      <form-section form-title="'Core parameters'">
        <form-section-field field-title="'Type'">
          <select
            ng-model="\$ctrl.accountType.accountSubtype"
            ng-options="o.value as o.label for o in \$ctrl.subtypes"
            ng-change="\$ctrl.changeSubtype()"
            ng-disabled="\$ctrl.accountType.id"
            required>
          </select>
        </form-section-field>
        <form-section-field field-title="'Purpose'">
          <select
            ng-model="\$ctrl.accountType.purpose"
            ng-options="o.value as o.label for o in \$ctrl.purposes"
            required>
          </select>
        </form-section-field>
        <form-section-field field-title="'BRIS reporting category'">
          <select
            ng-model="\$ctrl.accountType.brisReportingProductCategory"
            ng-options="o as o | prettyEnum for o in \$ctrl.brisTypes"
            required>
          </select>
        </form-section-field>
        <form-section-field field-title="'When client already has an account for this product'">
          <select
            ng-model="\$ctrl.accountType.typeConflictStrategy"
            ng-options="o.value as o.label for o in \$ctrl.typeConflictStrategyOptions"
            required>
          </select>
        </form-section-field>
        <form-section-field field-title="'When client already has an account of the same type'">
          <select
            ng-model="\$ctrl.accountType.subtypeConflictStrategy"
            ng-options="o.value as o.label for o in \$ctrl.typeConflictStrategyOptions"
            required>
          </select>
        </form-section-field>
        <form-section-field field-title="'Is deposit required to activate the account?'">
          <select
            ng-model="\$ctrl.accountType.initialDepositRequired"
            boolean-options
            required>
          </select>
        </form-section-field>
        <form-section-field ng-if="\$ctrl.accountType.initialDepositRequired" field-title="'Allowed activation operations'">
          <multiselect items="\$ctrl.allowedDepositActivationOperations"
                       ng-model="\$ctrl.accountType.initialDepositOperations"
                       label-property="'label'"
                       value-property="'value'"
                       ng-required="true">
          </multiselect>
        </form-section-field>
        <form-section-field ng-if="\$ctrl.accountType.initialDepositRequired" field-title="'Minimum initial deposit'">
          <cash ng-model="\$ctrl.accountType.minInitialDepositAmount"
                required></cash>
        </form-section-field>
        <form-section-field ng-if="\$ctrl.accountType.initialDepositRequired"
                            field-title="'Require full initial deposit in one transaction?'">
          <select
            ng-model="\$ctrl.accountType.fullInitialDepositRequired"
            boolean-options
            required>
          </select>
        </form-section-field>
        <form-section-field field-title="'Allow loan officer / collector tagging'">
          <select
            ng-model="\$ctrl.accountType.allowCenterManagement"
            boolean-options
            required>
          </select>
        </form-section-field>
      </form-section>

      <form-section form-title="'Print document settings'">
        <form-section-field field-title="'Is this account with a passbook?'">
          <select
            ng-model="\$ctrl.passbookSupported"
            ng-change="\$ctrl.passbookConfigChange()"
            boolean-options
            required>
          </select>
        </form-section-field>
        <form-section-field field-title="'Allow withdrawal without passbook'" ng-if="\$ctrl.passbookSupported">
          <select
            ng-model="\$ctrl.passbookConfig"
            ng-options="o.value as o.label for o in \$ctrl.passbookConfigOptions"
            ng-change="\$ctrl.passbookConfigChange()"
            required>
          </select>
        </form-section-field>
        <form-section-field field-title="'Show passbook printing automatically after validation'"
                            ng-if="\$ctrl.passbookSupported">
          <select
            ng-model="\$ctrl.accountType.printPassbookAfterValidationSlip"
            boolean-options
            required>
          </select>
        </form-section-field>
        <form-section-field field-title="'Skip passbook printing after debit and credit memo'"
                            ng-if="\$ctrl.passbookSupported">
          <select
            ng-model="\$ctrl.accountType.skipPassbookForCreditDebitMemo"
            boolean-options
            required>
          </select>
        </form-section-field>
      </form-section>

      <form-section form-title="'Interest accrual settings'">
        <form-section-field field-title="'Interest accrual'">
          <select
            ng-model="\$ctrl.accountType.accrued"
            ng-change="\$ctrl.changeAccrued()"
            boolean-options
            required>
          </select>
        </form-section-field>
        <form-section-field field-title="'Accrue'" ng-if="\$ctrl.accountType.accrued">
          <select
            ng-model="\$ctrl.accountType.accrualScheduler.cycleType"
            ng-options="o.value as o.label for o in \$ctrl.accrualCycleType"
            required>
          </select>
        </form-section-field>
      </form-section>

      <form-section form-title="'Dormancy settings'">
        <form-section-field field-title="'Enable dormancy'">
          <select
            ng-model="\$ctrl.accountType.dormant"
            ng-change="\$ctrl.changeDormant()"
            boolean-options
            required>
          </select>
        </form-section-field>
        <form-section-field
          field-title="'Days of inactivity to be dormant'"
          ng-if="\$ctrl.accountType.dormant">
          <input type="number"
                 min="0"
                 ng-model="\$ctrl.accountType.dormantConfig.dormancyTerm"
                 required/>
        </form-section-field>
        <form-section-field
          field-title="'Allow interest for dormant accounts'"
          ng-if="\$ctrl.accountType.dormant">
          <select
            ng-model="\$ctrl.accountType.dormantConfig.allowInterest"
            required
            boolean-options>
          </select>
        </form-section-field>
      </form-section>
    </div>
    <div class="form-column">
      <form-section form-title="'Tax'">
        <form-section-field field-title="'Collect withholding tax in advance?'">
          <select
            ng-model="\$ctrl.accountType.collectAdvanceWithholdingTax"
            required
            boolean-options>
          </select>
        </form-section-field>
      </form-section>

      <automatic-transfer-arrangement
        ng-if="\$ctrl.accountType.accountSubtype === 'CHECKING'"
        model="\$ctrl.accountType.automaticTransferAgreement"
        trigger-command-tags="'ATA_TRIGGER'"
        credit-command-tags="'ATA_CREDIT'">
      </automatic-transfer-arrangement>

      <form-section form-title="'Basic interest settings'">
        <form-section-field field-title="'Divisor - days in year'">
          <select
            ng-model="\$ctrl.accountType.productDefinition.daysInYear"
            ng-options="o as o for o in \$ctrl.daysInYear"
            ng-change="\$ctrl.daysInYearChanged()"
            required>
          </select>
        </form-section-field>
        <div class="alert" ng-if=" \$ctrl.accountType.id != null &&
            (\$ctrl.originalCreditingScheduler.cycleType !== \$ctrl.accountType.creditingScheduler.cycleType)">
            <span>
            <strong>Any changes in crediting cycle will be applied only on the newly created accounts.</strong>
            </span>
        </div>
        <form-section-field field-title="'Credit to account'">
          <select
            ng-model="\$ctrl.accountType.creditingScheduler.cycleType"
            ng-options="o.value as o.label for o in \$ctrl.cycleTypes"
            ng-change="\$ctrl.cycleTypeChanged()"
            required>
          </select>
        </form-section-field>
        <form-section-field field-title="'Minimum balance to earn interests'">
          <cash ng-model="\$ctrl.accountType.interestMinimalBalance"
                required></cash>
        </form-section-field>
        <form-section-field field-title="'Pay partial interest when closed'">
          <select
            ng-model="\$ctrl.accountType.applyInterestOnClose"
            boolean-options
            required>
          </select>
        </form-section-field>
        <form-section-field field-title="'Supports group'">
          <select
            ng-model="\$ctrl.accountType.supportsGroup"
            boolean-options
            required>
          </select>
        </form-section-field>
        <form-section-field field-title="'Force default interest rate'">
          <select
            ng-model="\$ctrl.accountType.forceDefaultInterestRateOn"
            ng-options="o.value as o.label for o in \$ctrl.forceDefaultInterestRateOnOptions"
            required>
          </select>
        </form-section-field>
      </form-section>
    </div>
    <div class="form-column">
      <form-section form-title="'Automated actions'">
        <form-section-field field-title="'Automatically close 0.0 total balance accounts'">
          <select
            ng-model="\$ctrl.accountType.autoCloseInterval"
            ng-change="\$ctrl.changeAutoCloseInterval()"
            ng-options="o.value as o.label for o in \$ctrl.autoCloseIntervals"
            required>
          </select>
        </form-section-field>

        <form-section-field field-title="'No. of days allowed with 0.0 total balance (including today)'"
                            ng-if="\$ctrl.accountType.autoCloseInterval === 'DAILY'">
          <input
            type="number"
            ng-model="\$ctrl.accountType.autoCloseDaysGracePeriod"
            min="1"
            max="90"
            required>
        </form-section-field>

        <form-section-field field-title="'Automatically close accounts linked as contractual savings regardless of loan status?'"
                            ng-if="\$ctrl.accountType.autoCloseInterval && \$ctrl.accountType.autoCloseInterval !== 'NONE' && \$ctrl.accountType.accountSubtype === 'SAVINGS'">
          <select
            ng-model="\$ctrl.accountType.autoCloseContractualSavings"
            boolean-options
            required>
          </select>
        </form-section-field>

        <form-section-field field-title="'Automatically close accounts with 0.00 total balance due to inward charges?'"
                            ng-if="\$ctrl.accountType.accountSubtype !== 'SAVINGS'">
          <select
            ng-model="\$ctrl.accountType.autoCloseOnInwardCharges"
            boolean-options
            required>
          </select>
        </form-section-field>

      </form-section>

      <form-section form-title="'Product management'">
        <product-availability branches-to-select="\$ctrl.branches"
                              product-availability="\$ctrl.accountType.productDefinition.productAvailability"
                              available-in-branch-ids="\$ctrl.accountType.productDefinition.availableInBranchIds"></product-availability>
        <form-section-field field-title="'Allow product creation by agents'"
                            ng-if="\$ctrl.hasAgentReadPermission()">
          <select
            ng-model="\$ctrl.accountType.productDefinition.allowCreationByAgents"
            boolean-options
            required>
          </select>
        </form-section-field>

        <form-section-field field-title="'Allowed agent banking transactions'"
                            ng-if="\$ctrl.hasAgentReadPermission()">
          <multiselect
            items="\$ctrl.agentTransactions"
            ng-model="\$ctrl.accountType.productDefinition.allowedAgentTransactions"
            select-all-option="true"
            label-property="'label'"
            value-property="'value'"></multiselect>
        </form-section-field>
        <customer-type-constraint
          on-customer-type-change="\$ctrl.changeCustomerTypeConstraint"
          customer-type-constraints="\$ctrl.accountType.productDefinition.customerTypeConstraints">
        </customer-type-constraint>
        <form-section-field field-title="'Report type as'" ng-if="\$ctrl.accountType.accountSubtype === 'COMBO'">
          <select
            required
            ng-model="\$ctrl.accountType.accountReportingSubtype"
            ng-options="o.value as o.label for o in \$ctrl.reportingSubtypes">
          </select>
        </form-section-field>
        <form-section-field field-title="'Make available to customers within the specified age limit?'" ng-if="\$ctrl.allowedLimitByCustomerAge()">
          <select
            ng-model="\$ctrl.accountType.limitByCustomerAge"
            ng-change="\$ctrl.changeLimitByCustomerAge()"
            boolean-options
            required>
          </select>
        </form-section-field>
        <form-section-field field-title="'Minimum customer age required'" ng-if="\$ctrl.accountType.limitByCustomerAge">
          <input type="number"
            ng-model="\$ctrl.accountType.minCustomerAge"
            min="0"
            max="{{\$ctrl.accountType.maxCustomerAge}}"
            ng-required="\$ctrl.accountType.limitByCustomerAge">
          </input>
        </form-section-field>
        <form-section-field field-title="'Maximum customer age required'" ng-if="\$ctrl.accountType.limitByCustomerAge">
          <input type="number"
            min="{{\$ctrl.accountType.minCustomerAge}}"
            ng-model="\$ctrl.accountType.maxCustomerAge"
            ng-required="\$ctrl.accountType.limitByCustomerAge">
          </input>
        </form-section-field>
        <form-section-field field-title="'Product already expired?'">
          <select
            ng-model="\$ctrl.accountType.productDefinition.expired"
            boolean-options
            ng-disabled="!\$ctrl.accountType.id"
            required>
          </select>
        </form-section-field>
      </form-section>

      <form-section form-title="'Balance management'">
        <form-section-field field-title="'Maximum credit balance type'">
          <select
            required
            ng-model="\$ctrl.accountType.maxCreditBalanceType"
            ng-options="o.value as o.label for o in \$ctrl.maxCreditBalanceTypes">
          </select>
        </form-section-field>
        <form-section-field field-title="'Max credit balance'"
                            ng-if="\$ctrl.accountType.maxCreditBalanceType && \$ctrl.accountType.maxCreditBalanceType !== 'NONE'">
          <cash ng-model="\$ctrl.accountType.maxCreditBalance"
                min="0"
                ng-required="true">
          </cash>
        </form-section-field>
      </form-section>
    </div>
  </ng-form>
</div>
<div class="term-deposit-section" ng-show="\$ctrl.sectionType === 'charges'">
  <ng-form name="\$ctrl.chargesForm">
  <div ng-if="!\$ctrl.selectedFeeForEdit">
    <div class="form-column">
      <form-section form-title="'Official charges'">
        <form-section-field field-title="'Withholding tax'">
          <glue-container append-percentage="true">
            <input type="number"
                   disabled
                   ng-model="\$ctrl.accountType.withholdingTax"
                   required/>
          </glue-container>
        </form-section-field>
      </form-section>
      <form-section form-title="'Maintaining balance fee'">
        <form-section-field field-title="'When maintaining balance lower than'">
          <cash ng-model="\$ctrl.accountType.maintainingBalance"
                required></cash>
        </form-section-field>
        <form-section-field field-title="'Apply maintaining balance fee'">
          <cash ng-model="\$ctrl.accountType.maintainingCharge"
                required></cash>
        </form-section-field>
        <form-section-field field-title="'Calculate and apply&nbsp;fee'">
          <select
            disabled
            ng-model="\$ctrl.accountType.maintainingScheduler.cycleType"
            ng-options="o.value as o.label for o in \$ctrl.cycleTypes"
            required>
          </select>
        </form-section-field>
        <form-section-field field-title="'Info'" class="form-section-field--info">
          <span>Please note that maintaining balance fee is calculated according to the rules defined in BSP Circular 485</span>
        </form-section-field>
        <form-section-field field-title="'On insufficient funds'">
          <fee-overdraft-strategy
            exclude-option="'ERROR'"
            ng-model="\$ctrl.accountType.maintainingFeeOverdraftStrategy"/>
        </form-section-field>
      </form-section>
      <form-section form-title="'Dormancy charge'" ng-if="\$ctrl.accountType.dormant">
        <form-section-field field-title="'When dormant apply fee of'">
          <div class="horizontal">
            <cash ng-model="\$ctrl.accountType.dormantConfig.chargeAmount"
                  max="50"
                  required></cash>
            <cash ng-model="\$ctrl.dormancyChargeMax"
                  ng-disabled="true"></cash>
          </div>
        </form-section-field>
        <form-section-field
          field-title="'Apply fee when no balance movement for'">
          <glue-container append="'days'">
            <input type="number"
                   min="0"
                   ng-model="\$ctrl.accountType.dormantConfig.chargeTerm"
                   required/>
          </glue-container>
        </form-section-field>
        <form-section-field field-title="'Info'" class="form-section-field--info">
          <span>If 'Apply fee when balance below' is set to 0.00 charge will be applied regardless of account balance.</span>
        </form-section-field>
        <form-section-field
          field-title="'Apply fee when balance below'">
          <cash ng-model="\$ctrl.accountType.dormantConfig.chargeBalanceThreshold" required></cash>
        </form-section-field>
        <form-section-field field-title="'Calculate and apply&nbsp;fee'">
          <select
            disabled
            ng-model="\$ctrl.accountType.dormancyScheduler.cycleType"
            ng-options="o.value as o.label for o in \$ctrl.cycleTypes"
            required>
          </select>
        </form-section-field>
        <form-section-field field-title="'On insufficient funds'">
          <fee-overdraft-strategy
            exclude-option="'ERROR'"
            ng-model="\$ctrl.accountType.dormancyFeeOverdraftStrategy"/>
        </form-section-field>
      </form-section>

      <form-section form-title="'Self-transfer charge'">
        <form-section-field field-title="'Fee type'">
          <select
            ng-model="\$ctrl.accountType.selfTransferCharge.feeType"
            ng-options="o.value as o.label for o in \$ctrl.transferChargeFeeTypeOptions"
            ng-change="\$ctrl.changeSelfTransferChargeType()"
            required>
          </select>
        </form-section-field>
        <form-section-field ng-if="\$ctrl.accountType.selfTransferCharge.feeType === 'FIXED'" field-title="'Fixed amount'">
          <cash
            ng-model="\$ctrl.accountType.selfTransferCharge.fixedValue"
            required>
          </cash>
        </form-section-field>
        <form-section-field ng-if="\$ctrl.accountType.selfTransferCharge.feeType === 'PERCENTAGE'"
                            field-title="'Percentage value'">
          <glue-container append-percentage="true">
            <input
              min="0"
              type="number"
              ng-model="\$ctrl.accountType.selfTransferCharge.percentageValue"
              required />
          </glue-container>
        </form-section-field>
        <form-section-field field-title="'On insufficient funds'">
          <fee-overdraft-strategy ng-model="\$ctrl.accountType.selfTransferCharge.overdraftStrategy"></fee-overdraft-strategy>
        </form-section-field>
      </form-section>

      <form-section form-title="'Internal transfer charge'">
        <form-section-field field-title="'Fee type'">
          <select
            ng-model="\$ctrl.accountType.internalTransferCharge.feeType"
            ng-options="o.value as o.label for o in \$ctrl.transferChargeFeeTypeOptions"
            ng-change="\$ctrl.changeInternalTransferChargeType()"
            required>
          </select>
        </form-section-field>
        <form-section-field ng-if="\$ctrl.accountType.internalTransferCharge.feeType === 'FIXED'"
                            field-title="'Fixed amount'">
          <cash
            ng-model="\$ctrl.accountType.internalTransferCharge.fixedValue"
            required>
          </cash>
        </form-section-field>
        <form-section-field ng-if="\$ctrl.accountType.internalTransferCharge.feeType === 'PERCENTAGE'"
                            field-title="'Percentage value'">
          <glue-container append-percentage="true">
            <input
              min="0"
              type="number"
              ng-model="\$ctrl.accountType.internalTransferCharge.percentageValue"
              required />
          </glue-container>
        </form-section-field>
        <form-section-field field-title="'On insufficient funds'">
          <fee-overdraft-strategy ng-model="\$ctrl.accountType.internalTransferCharge.overdraftStrategy"></fee-overdraft-strategy>
        </form-section-field>
      </form-section>

    </div>
    <div class="form-column" ng-if="\$ctrl.accountType.accountSubtype !== 'SAVINGS'">
      <form-section form-title="'Unfunded service charge'">
        <form-section-field field-title="'Fixed amount'">
          <cash required
                ng-model="\$ctrl.accountType.unfundedServiceCharge"></cash>
        </form-section-field>
        <form-section-field field-title="'Passbook alias'">
          <input
            ng-disabled="true"
            type="text"
            ng-value="('APPLY_FEE_UNFUNDED_SERVICE_CHARGE' | translate:'OPERATION_SHORT_CODE') " />
        </form-section-field>
        <form-section-field field-title="'On insufficient funds'">
          <fee-overdraft-strategy
            ng-model="\$ctrl.accountType.unfundedServiceChargeOverdraftStrategy"></fee-overdraft-strategy>
        </form-section-field>
      </form-section>
      <form-section form-title="'Penalty per check/day'">
        <form-section-field field-title="'Fixed amount'">
          <cash ng-model="\$ctrl.accountType.fixedPenaltyPerCheckCharge"
                required></cash>
        </form-section-field>
        <form-section-field field-title="'Passbook alias'">
          <input
            ng-disabled="true"
            type="text"
            ng-value="('APPLY_FEE_FIXED_PENALTY_PER_CHECK' | translate:'OPERATION_SHORT_CODE') " />
        </form-section-field>
        <form-section-field field-title="'On insufficient funds'">
          <fee-overdraft-strategy
            ng-model="\$ctrl.accountType.fixedPenaltyPerCheckChargeOverdraftStrategy"></fee-overdraft-strategy>
        </form-section-field>
      </form-section>
      <form-section form-title="'Every & fraction of'">
        <form-section-field field-title="'Fixed amount'">
          <cash required
                ng-model="\$ctrl.accountType.variablePenaltyPerCheckCharge"></cash>
        </form-section-field>
        <form-section-field field-title="'Passbook alias'">
          <input
            ng-disabled="true"
            type="text"
            ng-value="('APPLY_FEE_VARIABLE_PENALTY_PER_CHECK' | translate:'OPERATION_SHORT_CODE') " />
        </form-section-field>
        <form-section-field field-title="'On insufficient funds'">
          <fee-overdraft-strategy
            ng-model="\$ctrl.accountType.variablePenaltyPerCheckChargeOverdraftStrategy"></fee-overdraft-strategy>
        </form-section-field>
      </form-section>
      <form-section form-title="'Presenting bank charge on return'">
        <form-section-field field-title="'Fixed amount'">
          <cash ng-model="\$ctrl.accountType.presentingBankCharge"
                required></cash>
        </form-section-field>
        <form-section-field field-title="'Passbook alias'">
          <input
            ng-disabled="true"
            type="text"
            ng-value="('APPLY_FEE_PRESENTING_BANK_CHARGE_ON_RETURN' | translate:'OPERATION_SHORT_CODE') " />
        </form-section-field>
        <form-section-field field-title="'On insufficient funds'">
          <fee-overdraft-strategy ng-model="\$ctrl.accountType.presentingBankChargeOverdraftStrategy"></fee-overdraft-strategy>
        </form-section-field>
      </form-section>
    </div>
    <div class="form-column" ng-if="\$ctrl.accountType.accountSubtype !== 'SAVINGS'">
      <form-section form-title="'Bank charge on SPO Funded'">
        <form-section-field field-title="'Fixed amount'">
          <cash
            ng-model="\$ctrl.accountType.spoCharge"
            required>
          </cash>
        </form-section-field>
        <form-section-field field-title="'Passbook alias'">
          <input
            ng-disabled="true"
            type="text"
            ng-value="('APPLY_FEE_BANK_CHARGE_ON_SPO' | translate:'OPERATION_SHORT_CODE')" />
        </form-section-field>
        <form-section-field field-title="'On insufficient funds'">
          <fee-overdraft-strategy ng-model="\$ctrl.accountType.spoChargeOverdraftStrategy"></fee-overdraft-strategy>
        </form-section-field>
      </form-section>
      <form-section form-title="'Bank charge on DAUD'">
        <form-section-field field-title="'Charge method'">
          <select
            required
            ng-model="\$ctrl.accountType.daudChargeDelegate"
            ng-options="o.value as o.label for o in \$ctrl.spoAndDaudChargeOptions">
          </select>
        </form-section-field>
        <form-section-field field-title="'Fixed amount'" ng-if="!\$ctrl.accountType.daudChargeDelegate">
          <cash ng-model="\$ctrl.accountType.daudCharge"
                required></cash>
        </form-section-field>
        <form-section-field field-title="'Passbook alias'">
          <input
            ng-disabled="true"
            type="text"
            ng-value="('APPLY_FEE_BANK_CHARGE_ON_DAUD' | translate:'OPERATION_SHORT_CODE') "/>
        </form-section-field>
        <form-section-field field-title="'On insufficient funds'">
          <fee-overdraft-strategy ng-model="\$ctrl.accountType.daudChargeOverdraftStrategy"></fee-overdraft-strategy>
        </form-section-field>
      </form-section>
      <form-section form-title="'SPO placement charge'">
        <form-section-field field-title="'Apply fee'">
          <select
            ng-model="\$ctrl.accountType.enableSpoPlacementCharge"
            boolean-options
            required>
          </select>
        </form-section-field>
        <form-section-field field-title="'Amount'" ng-if="\$ctrl.accountType.enableSpoPlacementCharge">
          <cash
            ng-model="\$ctrl.accountType.spoPlacementCharge"
            required>
          </cash>
        </form-section-field>
        <form-section-field field-title="'On insufficient funds'" ng-if="\$ctrl.enableSpoPlacementCharge">
          <fee-overdraft-strategy ng-model="\$ctrl.accountType.spoPlacementChargeOverdraftStrategy">
          </fee-overdraft-strategy>
        </form-section-field>
      </form-section>
    </div>
    <div class="form-column" ng-if="\$ctrl.hasAgentReadPermission()">
      <validator condition="\$ctrl.isAgentFeesConfigurationValid()"></validator>
      <form-section ng-if="\$ctrl.allowsAgentTransaction(\$ctrl.agentTransactionEnum.AGENT_ACCOUNT_BALANCE_INQUIRY)" form-title="'Agent fee on balance inquiry'">
        <form-section-field field-title="'Amount'">
          <cash
            ng-model="\$ctrl.accountType.agentBalanceInquiryCharge.fixedAmount"
            ng-class="{'nx-invalid': !\$ctrl.accountType.agentBalanceInquiryCharge.extraOptions.AGENT_CHARGE_COLLECTION_TYPE}"
            required
            ng-disabled="true">
          </cash>
        </form-section-field>
        <form-section-field>
          <button
            type="button"
            class="btn btn-warning"
            ng-click="\$ctrl.editFeeDefinition(\$ctrl.accountType.agentBalanceInquiryCharge)">
            Edit
          </button>
        </form-section-field>
      </form-section>
      <form-section ng-if="\$ctrl.allowsAgentTransaction(\$ctrl.agentTransactionEnum.AGENT_ACCOUNT_CASH_DEPOSIT)" form-title="'Agent fee on deposit'">
        <form-section-field field-title="'Amount'">
          <cash
            ng-model="\$ctrl.accountType.agentDepositCharge.fixedAmount"
            ng-class="{'nx-invalid': !\$ctrl.accountType.agentDepositCharge.extraOptions.AGENT_CHARGE_COLLECTION_TYPE}"
            required
            ng-disabled="true">
          </cash>
        </form-section-field>
        <form-section-field>
          <button type="button" class="btn btn-warning"
                  ng-click="\$ctrl.editFeeDefinition(\$ctrl.accountType.agentDepositCharge)">
            Edit
          </button>
        </form-section-field>
      </form-section>
      <form-section ng-if="\$ctrl.allowsAgentTransaction(\$ctrl.agentTransactionEnum.AGENT_ACCOUNT_CASH_WITHDRAWAL)" form-title="'Agent fee on withdrawal'">
        <form-section-field field-title="'Amount'">
          <cash
            ng-model="\$ctrl.accountType.agentWithdrawalCharge.fixedAmount"
            ng-class="{'nx-invalid': !\$ctrl.accountType.agentWithdrawalCharge.extraOptions.AGENT_CHARGE_COLLECTION_TYPE}"
            required
            ng-disabled="true">
          </cash>
        </form-section-field>
        <form-section-field>
          <button type="button" class="btn btn-warning"
                  ng-click="\$ctrl.editFeeDefinition(\$ctrl.accountType.agentWithdrawalCharge)">
            Edit
          </button>
        </form-section-field>
      </form-section>
      <form-section ng-if="\$ctrl.allowsAgentTransaction(\$ctrl.agentTransactionEnum.BILL_PAYMENT)" form-title="'Agent fee on bill payment'">
        <form-section-field field-title="'Amount'">
          <cash
            ng-model="\$ctrl.accountType.agentBillCharge.fixedAmount"
            required
            ng-disabled="true">
          </cash>
        </form-section-field>
        <form-section-field>
          <button type="button" class="btn btn-warning"
                  ng-click="\$ctrl.editFeeDefinition(\$ctrl.accountType.agentBillCharge)">
            Edit
          </button>
        </form-section-field>
      </form-section>
      <form-section ng-if="\$ctrl.allowsAgentTransaction(\$ctrl.agentTransactionEnum.PREPAID_PAYMENT)" form-title="'Agent fee on prepaid payment'">
        <form-section-field field-title="'Amount'">
          <cash
            ng-model="\$ctrl.accountType.agentPrepaidCharge.fixedAmount"
            required
            ng-disabled="true">
          </cash>
        </form-section-field>
        <form-section-field>
          <button type="button" class="btn btn-warning"
                  ng-click="\$ctrl.editFeeDefinition(\$ctrl.accountType.agentPrepaidCharge)">
            Edit
          </button>
        </form-section-field>
      </form-section>
      <form-section ng-if="\$ctrl.allowsAgentTransaction(\$ctrl.agentTransactionEnum.TOP_UP_PAYMENT)" form-title="'Agent fee on top-up payment'">
        <form-section-field field-title="'Amount'">
          <cash
            ng-model="\$ctrl.accountType.agentTopupCharge.fixedAmount"
            required
            ng-disabled="true">
          </cash>
        </form-section-field>
        <form-section-field>
          <button type="button" class="btn btn-warning"
                  ng-click="\$ctrl.editFeeDefinition(\$ctrl.accountType.agentTopupCharge)">
            Edit
          </button>
        </form-section-field>
      </form-section>
    </div>
    <div class="form-column">
      <form-section form-title="'ATM fees'">
        <form-section-field field-title="'Balance inquiry (issuer)'">
          <cash ng-model="\$ctrl.accountType.atmBalanceInquiryFee" required></cash>
        </form-section-field>
        <form-section-field field-title="'Withdrawal (issuer)'">
          <cash ng-model="\$ctrl.accountType.atmWithdrawalFee" required></cash>
        </form-section-field>
        <form-section-field field-title="'Inter-bank fund transfer (all)'">
          <cash ng-model="\$ctrl.accountType.atmInterBankFundTransferFee" required></cash>
        </form-section-field>
        <div class="alert">
          Balance inquiry and withdrawal fees are applied only for issuer (non-on-us) transactions.
          Inter-bank fund transfer operations always result in a fee being applied.
        </div>
      </form-section>

      <form-section form-title="'Transaction limit fee'">
        <form-section-field field-title="'Charge fee after the number of transactions has been reached?'">
          <select
            ng-model="\$ctrl.accountType.enableTransactionLimit"
            required
            ng-change="\$ctrl.resetTransactionLimitConfig()"
            boolean-options>
          </select>
        </form-section-field>
        <form-section-field field-title="'Complimentary transactions per period'"
                            ng-if="\$ctrl.accountType.enableTransactionLimit">
          <input type="number"
                 ng-model="\$ctrl.accountType.transactionLimit.extraOptions.TRANSACTION_LIMIT_CONFIG.limit"
                 required
                 min="0"/>
        </form-section-field>
        <form-section-field field-title="'Period covered'"
                            ng-if="\$ctrl.accountType.enableTransactionLimit">
          <select
            ng-model="\$ctrl.accountType.transactionLimit.extraOptions.TRANSACTION_LIMIT_CONFIG.period"
            ng-options="o.value as o.label for o in \$ctrl.transactionLimitPeriods"
            required>
          </select>
          </form-section-field>
        <form-section-field field-title="'Fee amount'"
                            ng-if="\$ctrl.accountType.enableTransactionLimit">
          <cash ng-model="\$ctrl.accountType.transactionLimit.fixedAmount" required></cash>
        </form-section-field>
        <form-section-field field-title="'Restricted operations'"
                            ng-if="\$ctrl.accountType.enableTransactionLimit">
          <multiselect items="\$ctrl.restrictedAccountCommands"
                       ng-model="\$ctrl.accountType.transactionLimit.extraOptions.TRANSACTION_LIMIT_CONFIG.restrictedCommands"
                       label-property="'label'"
                       value-property="'value'"
                       ng-required="true">
          </multiselect>
        </form-section-field>
      </form-section>
    </div>
  </div>
  <div ng-if="\$ctrl.selectedFeeForEdit">
    <custom-fee-edit
      fee="\$ctrl.selectedFeeForEdit"
      product-group="'ACCOUNT'"
      on-save="\$ctrl.saveFeeDefinition()"
      on-cancel="\$ctrl.cancelFeeDefinitionEdition()">
    </custom-fee-edit>
  </div>
  </ng-form>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/deposit-account/section/deposit-account-section.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;